import React from 'react';
import { HeroSectionView } from './HeroSectionView';

function HeroSection() {
  return (
    <HeroSectionView />
  );
}

export default HeroSection;

